import { useState, useEffect } from 'react'

import Collection from '../Collection/Collection'

import {
    slugify,
    getProducts,
    isEven,
    getUniqueListBy,
} from '../../helpers/helpers'

const boostLiveUrl =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&product_available=true&variant_available=true&collection_scope='

const CollectionBlock = ({ collection }) => {
    // console.log('collection', collection)
    // console.log('collection in collection, collectionTitle', collection, collection.collectionTitle)

    const [data, setData] = useState()
    const [numProducts, setNumProducts] = useState(0)
    const [active, setActive] = useState({
        id: 0,
        slug: collection.filterTabs[0].slug,
        type: collection.filterTabs[0].valueType,
        values: collection.filterTabs[0].values,
    })

    // const [filterCounts, setFilterCounts] = useState({
    //     nursery_furniture: 0,
    //     cribs_bassinets: 0,
    //     crib_mattresses: 0,

    // })

    const collectionId = collection.collectionId
    const collectionSlug = slugify(collection.collectionTitle)
    // const sized = collection.sized ? collection.sized : false
    let slicedProducts

    const url = boostLiveUrl + collectionId
    // console.log('url in CollectionBlock', url)

    const guideItem = collection.guideItem
    // const guideItemPosition = collection.guideItem.guideItemPosition
    const numItems = collection.numItems ? collection.numItems : 7

    let filterTabs = collection.filterTabs

    let filterCount = []
    let filterCountEntries = []
    let filterCountEntriesFlat = []

    let tabCount

    filterTabs = filterTabs.filter((t) => {
        return !t.hide
    })

    // console.log('filterTabs filtered', filterTabs)

    useEffect(() => {
        fetch(url).then((res) =>
            res.json().then((productData) => {
                // console.log(
                //     'productData',
                //     collection.collectionTitle,
                //     productData
                // )
                let numberOfProducts = productData.total_product
                setNumProducts(numberOfProducts)
            })
        )
    }, [collectionId, url, collection.collectionTitle])

    let pages

    // calculate number of "pages" of data in collection
    if (numProducts) {
        pages = Math.ceil(numProducts / 70)
    }

    useEffect(() => {
        getProducts(pages, url).then((queriedData) => {
            if (queriedData && queriedData.length) {
                setData(queriedData.flat(1))
            }
        })

        return () => setData()
    }, [url, pages])

    if (data && data.length) {
        // console.log('data', data)
        let products = [...data]

        let availableProducts = products.filter((p) => {
            return p.available
        })

        slicedProducts = availableProducts.slice(0, numItems)

        // console.log(
        //     'slicedProducts',
        //     collection.collectionTitle,
        //     slicedProducts
        // )

        let variants = []

        products.map((p) => {
            variants.push(p.variants)
            variants = variants.flat()
            return null
        })

        // console.log('filterTabs, variants', filterTabs, variants)

        variants.map((v) => {
            filterTabs.map((f) => {
                // console.log('f, v.barcode', f, v.barcode)
                // console.log('v', v)
                let values = f.values
                values.map((m) => {
                    if (v.product_type === m && v.inventory_quantity > 0) {
                        filterCount.push({
                            tab: f.title,
                            item: v,
                        })
                    }
                    return null
                })

                return null
            })
            return null
        })

        // console.log('filterCount: ', filterCount)

        let filterCountByKey = groupByKey(filterCount, 'tab')

        // console.log('filterCountByKey: ', filterCountByKey)

        filterCountEntries = Object.entries(filterCountByKey)

        // console.log('filterCountEntries', filterCountEntries)

        filterCountEntries.map((m) => {
            filterCountEntriesFlat.push(m[1])
            return null
        })

        filterCountEntriesFlat = getUniqueListBy(
            filterCountEntriesFlat,
            'product_id'
        )

        // console.log('filterCountEntriesFlat', filterCountEntriesFlat)
    }

    function groupByKey(array, key) {
        return array.reduce((hash, obj) => {
            if (obj[key] === undefined) return hash
            return Object.assign(hash, {
                [obj[key]]: (hash[obj[key]] || []).concat(obj),
            })
        }, {})
    }

    // console.log('active on load', active, collection.collectionTitle)

    let numOfFilters

    if (collection.filterTabs && collection.filterTabs.length) {
        numOfFilters = collection.filterTabs.length
    } else {
        numOfFilters = 2
    }

    return (
        <div
            className={`collection-block-outer ${collectionSlug}`}
            data-collection-id={collection.collectionId}
            id={collectionSlug}
        >
            <div className="collection-block-inner">
                <div className="collection-block-heading">
                    <h2>{collection.collectionTitle}</h2>
                </div>
                <div className="collection-tabs-outer">
                    <div className="collection-tabs-inner">
                        <ul
                            className={`nostyle collection-tabs ${
                                isEven(numOfFilters)
                                    ? 'even-filters'
                                    : 'odd-filters'
                            }`}
                        >
                            {filterTabs ? (
                                filterTabs.map((t, i) => {
                                    // console.log('t.values', t.values, typeof t.values)
                                    return (
                                        <li
                                            key={`${collection.id}-${
                                                collectionSlug
                                                    ? collectionSlug + '-' + i
                                                    : 'slug_' + i
                                            }`}
                                            className={`${collectionSlug}-tab collection-tab ${
                                                active.id === t.id
                                                    ? 'tab-active'
                                                    : ''
                                            }`}
                                            onClick={() =>
                                                setActive({
                                                    id: t.id,
                                                    slug: t.slug,
                                                    valueType: t.valueType,
                                                    values: t.values,
                                                })
                                            }
                                        >
                                            <span
                                                className="tab-title"
                                                data-tab-slug={t.slug}
                                                data-value-type={t.value}
                                                data-values={t.values}
                                            >
                                                {filterCountEntries.map((f) => {
                                                    if (f[0] === t.title) {
                                                        let items = []
                                                        f[1].map((item) => {
                                                            items.push(
                                                                item.item
                                                            )
                                                            return null
                                                        })
                                                        const unique = [
                                                            ...new Set(
                                                                items.map(
                                                                    (x) =>
                                                                        x.product_id
                                                                )
                                                            ),
                                                        ]
                                                        // console.log(
                                                        //     'unique: ',
                                                        //     unique
                                                        // )

                                                        tabCount = unique.length
                                                    }
                                                    return null
                                                })}
                                                {t.title}{' '}
                                                {tabCount && tabCount > 0
                                                    ? `(${tabCount})`
                                                    : null}
                                            </span>
                                        </li>
                                    )
                                })
                            ) : (
                                <div>Loading...</div>
                            )}
                        </ul>
                    </div>
                </div>
                <div className="products-outer">
                    <div className="products-inner">
                        {slicedProducts ? (
                            <Collection
                                active={active}
                                collection={collection}
                                productData={data}
                                products={slicedProducts}
                                numItems={numItems}
                                guideItem={guideItem}
                            />
                        ) : (
                            <div>Loading...</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CollectionBlock
